<div class="modal" [ngClass]="{'show' :config?.showOrderMessage}">
  <div class="modal-content">
    <div class="modal-content__body-container">
      <div class="empty-container">
        <h3 class="marginBottom70" [translate]="'eos-tv-shop-ii.title.order-message'"></h3>

        <div>
          <p class="marginBottom40" [innerHTML]="'eos-tv-shop-ii.text.order-message' | translate:orderMessageParams"></p>
        </div>
        <app-navigable-button
          [x]="0"
          [y]="0"
          [ownerComponent]="componentName"
          class="btn-grey"
          (emitOnEnterPressed)="onEmitCloseOrderMessage()"
          (emitOnBack)="onBack()">
          <span [translate]="'eos-tv-shop-ii.btn.order-failed-close'"></span>
        </app-navigable-button>
      </div>
    </div>
  </div>
</div>
